// hooks/useRightPanelProps.js
import { useTranslation } from 'react-i18next'
import { DUAL_PANEL_SELECTABLE_TYPES } from '../../../constants/dual-panel-selector-constants'
import classes from './PostAnnouncementModal.module.scss'
import { ReactComponent as FlagIcon } from '../../../assets/images/common/icons/Flag.svg'

export const useRightPanelProps = (selectedPrograms, selectedSeries, selectedStudents, selectedCoaches) => {
  const { t } = useTranslation()

  const totalStudents =
    selectedPrograms?.reduce((acc, program) => acc + program?.students?.length, 0) +
    selectedSeries?.reduce((acc, series) => acc + series?.students?.length, 0) +
    selectedStudents?.length

  const rightPanelText = t('dashboard.coach.useRightPanelProps.summary', {
    programs: t('dashboard.coach.useRightPanelProps.programCount', { count: selectedPrograms?.length }),
    series: t('dashboard.coach.useRightPanelProps.seriesCount', { count: selectedSeries?.length }),
    students: t('dashboard.coach.useRightPanelProps.studentCount', { count: totalStudents }),
    coaches: t('dashboard.coach.useRightPanelProps.coachCount', { count: selectedCoaches?.length }),
  })

  const SummaryPlaceholder = () => (
    <div className={classes.placeholder}>
      <FlagIcon className={classes.icon} />
      <h2 className={classes.title}>{t('dashboard.coach.useRightPanelProps.emptyTitle')}</h2>
      <p className={classes.description}>{t('dashboard.coach.useRightPanelProps.emptyDescription')}</p>
    </div>
  )

  return {
    selectedItems: [...selectedPrograms, ...selectedSeries, ...selectedStudents, ...selectedCoaches],
    selectedItemType: DUAL_PANEL_SELECTABLE_TYPES.students,
    summaryTitle: rightPanelText,
    summaryPlaceholder: <SummaryPlaceholder />,
  }
}
